// Antd
import { Col, Row } from 'antd'
import styles from './styles.module.scss'
import src from './CoverImage.png'
import LoginCard from './LoginCard'

const { REACT_APP_VERSION } = process.env

const LoginPage: React.FC = () => {
  return (
    <Row className={styles.loginPage}>
      <Col span={16} className="loginForm">
        <LoginCard />
      </Col>
      <Col span={8} className="cover">
        <span className="versionLabel">v {REACT_APP_VERSION}</span>
        <img src={src} alt="" />
        <div className="coverPosition gradientCover" />
        <div className="coverPosition gray" />
      </Col>
    </Row>
  )
}

export default LoginPage
